import styled from "styled-components";
import {getCssSizeValue} from "@/utils/utils";
import GridContainer from "@/components/common/GridContainer";
import {BREAKPOINTS, colors} from "@/styles/themeSettings";
import Partners from "@/components/TilesModule/variants/WhoHelpsTilesModule/Partners";
import TeamMembersContainer from "@/components/TilesModule/variants/WhoHelpsTilesModule/TeamMembersContainer";
import {WHO_HELPS_VARIANTS} from "@/constants";
import {formatImageCMSData} from "@/components/common/Image";
import React from "react";
import HeaderDescriptionBlock from "@/components/HeaderDescriptionBlock";
import useColor from "@/hooks/useColor";

const StyledWrapper = styled.section`
    background: ${({$bgColor}) => $bgColor};
`

export const StyledTileIndicator = styled.div`
    position: absolute;
    left: 0;
    top: ${getCssSizeValue(-24, BREAKPOINTS.MOBILE)};
	font-weight: ${({ theme }) => theme.fontWeight.bold};

    @media (min-width: ${({theme}) => theme.breakpoints.tablet}px) {
        top: ${getCssSizeValue(-34, BREAKPOINTS.TABLET)};
    } 

    @media (min-width: ${({theme}) => theme.breakpoints[BREAKPOINTS.DESKTOP]}px) and (orientation: landscape) {
        top: ${getCssSizeValue(-32)};
    }
`

const HeaderAndDescription = styled(HeaderDescriptionBlock)`
    translate: 0 ${getCssSizeValue(-34)};
`

function getVariantBasedOnTeamMembersLength(teamMembers) {
	switch (teamMembers.length) {
		case 0 || 1:
			return WHO_HELPS_VARIANTS.DEFAULT
		case 2:
			return WHO_HELPS_VARIANTS.TWO_TEAM_MEMBERS
		default:
			return WHO_HELPS_VARIANTS.MANY
	}
}


function getWhoHelpsTilesModuleData(data) {
	const id = data?.id || ''
	const indent = data?.indent || 1
	const teamMemberTitle = data?.teamMemberTitle || ''
	const partnerTitle = data?.partnerTitle || ''
	const teamMembers = data?.teamMembers || []
	const partners = data?.partners || []
	const variant = getVariantBasedOnTeamMembersLength(teamMembers)
	const backgroundColor = data?.backgroundColor || colors.platinum

	return {
		id,
		indent,
		teamMemberTitle,
		partnerTitle,
		teamMembers,
		partners,
		variant,
		backgroundColor
	}
}

export default function WhoHelpsTilesModule({data, paddings, headerDescription}) {
	const {id, indent, teamMemberTitle, partnerTitle, teamMembers, partners, variant, backgroundColor} = getWhoHelpsTilesModuleData(data)
	const bgColor = useColor(backgroundColor)
	const indentClassName = variant === WHO_HELPS_VARIANTS.DEFAULT ? indent : 0
	const memberIcon = formatImageCMSData(data?.memberIcon || {})

	const renderTeamMembers = teamMembers?.length !== 0
	const borderColor = bgColor === colors.platinum ? colors.slateGray : null

	return <StyledWrapper
		id={id}
		className={paddings}
		$bgColor={bgColor}
	>
		<HeaderAndDescription headerDescription={headerDescription} borderColor={borderColor} />
		<GridContainer className={`indent-desktop-${indentClassName} second`}>
			{renderTeamMembers && (
				<TeamMembersContainer
					teamMembers={teamMembers}
					teamMemberTitle={teamMemberTitle}
					variant={variant}
					memberIcon={memberIcon}
					partners={partners}
				/>
			)}
			<Partners partners={partners} partnerTitle={partnerTitle} variant={variant}/>
		</GridContainer>
	</StyledWrapper>
}